import type { AlgoliaProduct } from "@lib/wrappers/algolia/types";
import { normalizeAlgoliaProducts } from "@lib/wrappers/algolia/helpers";
import { resolveProductDisplayName } from "@lib/product/productNamePolicy";
import type { Hit } from "instantsearch.js";
import { useInfiniteHits } from "react-instantsearch";

const transformProductNames = (hits: Hit<AlgoliaProduct>[]): Hit<AlgoliaProduct>[] =>
    hits.map((hit) => ({
        ...hit,
        name: resolveProductDisplayName(hit),
    }));

interface NormalizedInfiniteHits {
    hits: Hit<AlgoliaProduct>[];
    numberOfHits: number;
    resultQuery: string;
    isFirstPage: boolean;
    isLastPage: boolean;
    currentPageHits: AlgoliaProduct[];
}

export function useNormalizedInfiniteHits(): NormalizedInfiniteHits {
    const { hits, currentPageHits, results, isFirstPage, isLastPage } =
        useInfiniteHits<AlgoliaProduct>({ transformItems: transformProductNames });

    return {
        hits,
        numberOfHits: results?.nbHits ?? 0,
        resultQuery: results?.query ?? "",
        isFirstPage,
        isLastPage,
        currentPageHits: normalizeAlgoliaProducts(currentPageHits),
    };
}
